// frontend/src/components/visitor/CurrencySelector.tsx
import React, { useState } from 'react';
import { DollarSign, ChevronDown } from 'react-feather';
import { useCurrency } from '../../contexts/CurrencyContext';
import { motion, AnimatePresence } from 'framer-motion';

const CurrencySelector: React.FC = () => {
  const { currency, setCurrencyByCode, availableCurrencies } = useCurrency();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="relative">
      {/* Currency selector button */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center p-2 rounded-full hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors duration-200"
        aria-label="Select currency"
        aria-expanded={isOpen}
        aria-haspopup="true"
      >
        <DollarSign size={20} className="text-gray-700 dark:text-gray-300" />
        <span className="ml-1 text-gray-700 dark:text-gray-300">{currency.code}</span>
        <ChevronDown size={16} className="ml-1 text-gray-500 dark:text-gray-400" />
      </button>

      {/* Dropdown menu for currencies */}
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            transition={{ duration: 0.2 }}
            className="absolute right-0 mt-2 w-56 py-2 bg-white dark:bg-gray-800 rounded-lg shadow-xl z-10 border border-gray-200 dark:border-gray-700"
          >
            <div className="px-3 py-2 text-sm font-medium text-gray-600 dark:text-gray-300 border-b border-gray-200 dark:border-gray-700">
              Select Currency
            </div>
            {availableCurrencies.map((currencyOption) => (
              <button
                key={currencyOption.code}
                onClick={() => {
                  setCurrencyByCode(currencyOption.code);
                  setIsOpen(false);
                }}
                className={`w-full flex items-center px-4 py-2 text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 ${
                  currency.code === currencyOption.code ? 'font-semibold' : ''
                }`}
              >
                <span className="inline-block w-8 text-left mr-2">
                  {currencyOption.symbol}
                </span>
                <span className="flex-grow text-left">
                  {currencyOption.name}
                </span>
                {currency.code === currencyOption.code && (
                  <span className="ml-auto">✓</span>
                )}
              </button>
            ))}
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default CurrencySelector;